export class AppUserContext {
  constructor() {
    this.UserID = '';
    this.FeatureID = '';
    this.CompanyID = '';
    this.ExternalAppURL = '';
    this.ExternalAppID = '';
  }
}
